import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { useNetworkHealthStore } from "../../utils/networkHealth";

// Shown the moment a network-level request failure happens (see axios.ts's
// handleNetworkError) — before networkHealth.ts decides whether it's serious
// enough to escalate to a full /maintenance redirect. A transient CORS/DNS
// blip resolves within the grace window and this just disappears again; a
// real outage escalates to /maintenance shortly after, same as before this
// change, just no longer instantly on the very first failed request.
export const NetworkHealthBanner: React.FC = () => {
  const status = useNetworkHealthStore((state) => state.status);
  if (status !== "degraded") return null;

  return (
    <Box
      sx={{
        backgroundColor: "#7A5B00",
        color: "#ffffff",
        py: 0.75,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        width: "100%",
        flexShrink: 0,
      }}
    >
      <CircularProgress size={14} thickness={5} sx={{ color: "inherit" }} />
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{ color: "inherit", textAlign: "center" }}
      >
        Bağlantı sorunu yaşanıyor, yeniden deneniyor...
      </Typography>
    </Box>
  );
};
